/**
 * GE Client SDK 이벤트 등록 — 큐 초기화 패턴의 **유일한 사본**.
 *
 * 종전엔 `checkout-analytics.ts` 가 이 패턴을 직접 들고 있었다. 두 번째 이벤트(#5843 웰컴 팝업
 * 「change shipping country」)가 생기면서 두 벌이 되지 않게 여기로 뺐다.
 *
 * ## 큐 이름 — `glegem` 이 실제로 쓰인다
 *
 * GE 문서(Events Summary): *"the correct queue name for event registration is “glegem” (and
 * not “gle”)"* — Module 플랫폼 주의. dev(INT, AU) 실측 2026-09-29: 웰컴 팝업 이벤트는 **`glegem`
 * 에서만** 왔다(`gle` 에 건 리스너는 안 불렸다). `gle` 에도 거는 이유는 종전 등록과 같다 — SDK 가
 * 실제로 쓰는 큐에서만 실행되고 나머지는 처리되지 않아 무해하다. 콜백은 **멱등**이어야 한다.
 *
 * 등록 패턴은 GE 문서의 self-invoking 초기화와 같다(큐 선생성 → 등록) → SDK 로드 전/후 무관.
 */
export const GE_SDK_QUEUE_NAMES = ["glegem", "gle"] as const;

type GeQueue = ((...args: unknown[]) => void) & { q?: unknown[] };

export function onGeSdkEvent(
  event: string,
  callback: (...args: never[]) => void,
): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as Record<string, GeQueue>;
  GE_SDK_QUEUE_NAMES.forEach((name) => {
    // 없으면 큐를 만들고, 있으면(실 SDK 함수) 그대로 쓴다.
    w[name] =
      w[name] ||
      function (this: unknown, ...args: unknown[]) {
        (w[name].q = w[name].q || []).push(args);
      };
    w[name](event, callback);
  });
}
